import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus, AiOutlineClose } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { AiOutlineClose as CloseIcon } from 'react-icons/ai';
import { GetOutward, AddOutwardCourier, UpdateOutwardCourier, GetCouriers, GetDepartment } from '../../services/Api';
import "./OutwardCourier.css";
import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
// Your existing code...


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
      color:#2B3497;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;
const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;


  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
// const Input = styled.input`
//   width: 100%;
//   padding: 8px 0;
//   border: none;
//   border-bottom: 1px solid #2B3497;
//   font-family: 'Segoe UI', 'Regular';
//   margin-top:10px;
//   background: transparent;
//   &:focus {
//     outline: none;
//     border-bottom: 2px solid #2B3497;
//   }
// `;
const TextArea = styled.textarea`
   width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  font-family: 'Segoe UI', 'Regular';
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  }
`;

const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const LocationInput = styled.input`
  border: none;
  border-bottom: 2px solid #3d46b4;
  outline: none;
  font-size: 16px;
  padding: 10px;
  margin-left: 20px;
  width: 200px;
  background: transparent;
`;

const TableContainer = styled.div`
  margin-top: 20px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
      cursor: pointer;

`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
const Asterisk = styled.span`
  color: red;
`;

// const DropdownSelect = styled.select`
//   background-color: #fff;
//   color: #293495;
//   boder:none;
//   border-bottom: 1px solid #3d46b4;
//   padding: 8px;
//   border-radius: 5px;
//   cursor: pointer;
//   font-size: 16px;
//   &:focus {
//     outline: none;
//     border-color: #293495;
//   }
// `;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 1px #0000004A;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;
export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 29px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  z-index: 1000;
  width: 80%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom:10px;
`;

export const ModalTitle = styled.h2`
  color: #293495;
  font-size: 20px;
  margin: 0;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FlexRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const InputFieldHalf = styled.div`
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #000;
  font-weight: 600;
`;

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 2px solid ${props => (props.$hasError ? 'red' : '#2B3497')};
  font-family: 'Segoe UI', Regular;
  background: transparent;

  &:focus {
    outline: none;
    border-bottom: 2px solid ${props => (props.$hasError ? 'red' : '#2B3497')};
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  font-family: 'Segoe UI', 'Regular';
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  }
`;

const DropdownSelect = styled.select`
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#293495')};
  padding: 8px 5px;
  font-size: 14px;
  outline: none;
  background: transparent;
  background-image: url('data:image/svg+xml;utf8,<svg fill="none" stroke="${props =>
    props.hasError ? 'red' : '%23293495'}" stroke-width="2" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px 16px;
  cursor: pointer;

  &:focus {
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#1a237e')};
  }
`;

export const ResetButton = styled.button`
   background-color: red;
margin-top: 20px;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: darkred;
  }
`;

export const SubmitButton = styled.button`
 margin-top: 20px;
  background-color: #293495;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: #1f2970;
  }
`;

const dummyData = [
  {
    courierName: "Amazon Package",
    dateTime: "2025-04-05T10:30:00",
    docketNumber: "DK12345",
    toAddress: "Office, LA",
    department: "Logistics",
    quantity: 1,
    remarks: "Handle with care",
  },
  {
    courierName: "FedEx Delivery",
    dateTime: "2025-04-06T14:45:00",
    docketNumber: "DK54321",
    toAddress: "Warehouse, NY",
    department: "Procurement",
    quantity: 3,
    remarks: "Urgent",
  },
  {
    courierName: "DHL Shipment",
    dateTime: "2025-04-07T08:20:00",
    docketNumber: "DK98765",
    toAddress: "Head Office, SF",
    department: "Admin",
    quantity: 2,
    remarks: "Fragile",
  },
];


const OutwardCourierPage = () => {
  const [showInput, setShowInput] = useState(false);
  const [locationName, setLocationName] = useState('');
  const [locations, setLocations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showPagination, setShowPagination] = useState(false);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');

  // Sort function
  const rowsPerPage = 5;

  const [outwardCourierData, setOutwardCourierData] = useState([]);
  const [couriers, setCouriers] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [outwardDate, setOutwardDate] = useState(() => {
    const today = new Date().toISOString().split('T')[0];
    return today;
  });

  const fetchOutward = async () => {
    try {
      const response = await GetOutward(outwardDate);
      setOutwardCourierData(response?.TableData);
    } catch (error) {
      console.error("Error Fetching Outward Data", error)
    }
  }

  useEffect(() => {
    if (outwardDate) {
      fetchOutward();
    }
  }, [outwardDate])



  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axios.get('/Location');
        if (response.data) {
          // Assuming the API returns an array of locations
          setLocations(response.data);
          setShowPagination(true); // Show pagination after submitting at least one row

        } else {
          setLocations([]); // Ensure locations is always an array
        }
      } catch (error) {
        console.error('Error fetching locations:', error);
        setLocations([]); // Ensure locations is always an array even if the request fails
      }
    };

    const fetchCouriers = async () => {
      try {
        const response = await GetCouriers();
        setCouriers(response);

      } catch (error) {
        console.error('Error fetching Courers name:', error);
      }
    }

    const fetchDepartment = async () => {
      try {
        const response = await GetDepartment();
        setDepartments(response);
      } catch (error) {
        console.error('Error fetching Courers name:', error);
      }
    }

    fetchDepartment();
    fetchCouriers();
    fetchLocations();
  }, []);
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  // const handleSort = (column) => {
  //   const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
  //   setSortColumn(column);
  //   setSortDirection(direction);
  //   const sortedData = sortData(locations, column, direction);
  //   setLocations(sortedData);
  // };


  const handleAddLocationClick = () => {
    handleReset();
    setIsModalOpen(true)
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsEditing(false);
    setErrors({});
  }

  // const handleEdit = (location) => {
  // }


  const handleDelete = (id) => {
    confirmAlert({
      title: <span style={{ color: '#dc3545' }}>Warning</span>,
      message: 'Are you sure you want to delete this location?',
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              // Sending the PUT request to mark the location as deleted
              await axios.put('/Location', {
                id: id,
                locationName: locations.find(location => location.id === id)?.locationName,
                isDeleted: true
              });

              // Update the local state to remove the deleted location from the UI
              setLocations((prevData) => prevData.filter(location => location.id !== id));

              // Show success toast message
              toast.success('Location Deleted Successfully');
            } catch (error) {
              console.error('Error deleting location:', error);
              // Show error toast message
              toast.error('Failed to Delete Location');
            }
          }
        },
        {
          label: 'No',
          onClick: () => {
            // Close dialog without taking any action
          }
        }
      ]
    });
  };


  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Safely filter the data
  const filteredLocations = Array.isArray(outwardCourierData)
    ? outwardCourierData.filter(item => {
      const term = searchTerm?.toLowerCase().trim();
      if (!term) return true;

      const excludeKeys = ['CreatedBy', 'CreatedOn', 'ModifiedBy', 'ModifiedOn'];

      return Object.entries(item).some(([key, value]) =>
        !excludeKeys.includes(key) &&
        String(value ?? '').toLowerCase().includes(term)
      );
    })
    : []; // fallback to empty array if data is not an array

  // Pagination logic
  const itemsPerPage = 5;
  const totalItems = filteredLocations.length;
  const maxPage = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const safeCurrentPage = Math.min(currentPage, maxPage); // Prevent out-of-bound slice
  const indexOfLastItem = safeCurrentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLocations.slice(indexOfFirstItem, indexOfLastItem);





  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const totalPages = Math.ceil(filteredLocations.length / rowsPerPage);

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredLocations.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

    let startPage = Math.max(currentPage - 5, 1);
    let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

    // Adjust startPage if endPage exceeds totalPages
    if (endPage === totalPages) {
      startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <PaginationButton
          key={i}
          className={currentPage === i ? 'active' : ''}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </PaginationButton>
      );
    }

    return pageNumbers;
  };
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState('');

  const closePopup = () => {
    setIsPopupVisible(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);


  const [uploadDocs, setUploadDocs] = useState(false);
  const [uploadNDA, setUploadNDA] = useState(false);
  const [uploadTraining, setUploadTraining] = useState(false);
  const [uploadSafety, setUploadSafety] = useState(false);
  const [documentFile, setDocumentFile] = useState('');
  const [ndaFile, setNdaFile] = useState('');
  const handleReset = () => {
    setShowOtherCourierInput(false)
    setUploadDocs(false);
    setUploadNDA(false);
    setUploadTraining(false);
    setUploadSafety(false);
    setDocumentFile('');
    setNdaFile('');


    // Reset form & refresh data
    setFormData({
      courierName: '',
      courierId: '',
      dateTime: '',
      fromAddress: '',
      toAddress: '',
      docketNo: '',
      departmentId: '',
      Department: '',
      quantity: '',
      remarks: '',
    });
    // reset any other form fields here
  };

  const [formData, setFormData] = useState({
    courierName: '',
    courierId: '',
    dateTime: '',
    fromAddress: '',
    toAddress: '',
    docketNo: '',
    departmentId: '',
    Department: '',
    quantity: '',
    remarks: '',
  });

  const [showOtherCompany, setShowOtherCompany] = useState(false);
  const [data, setData] = useState(dummyData);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});

  const handleSort = (column) => {
    const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(newDirection);
    console.log("outward data", outwardCourierData);

    const sortedData = [...outwardCourierData].sort((a, b) => {
      let valA = a[column];
      let valB = b[column];

      if (column === 'dateTime') {
        valA = new Date(valA);
        valB = new Date(valB);
      }

      if (valA < valB) return newDirection === 'asc' ? -1 : 1;
      if (valA > valB) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setOutwardCourierData(sortedData);
  };

  const [showOtherCourierInput, setShowOtherCourierInput] = useState(false);


  const handleSubmit = async () => {

    const newErrors = {};
    if (formData.courierId === "0" && !formData.courierName?.trim()) {
      setErrors(prev => ({ ...prev, courierName: 'Courier Name is required' }));
      return;
    }

    // Basic validation
    if (!String(formData.courierId).trim()) newErrors.courierId = 'Courier Name is required.';
    if (!String(formData.dateTime).trim()) newErrors.dateTime = 'Date and time are required.';
    if (!String(formData.fromAddress).trim()) newErrors.fromAddress = 'From address is required.';
    if (!String(formData.toAddress).trim()) newErrors.toAddress = 'To address is required.';
    if (!String(formData.docketNo).trim()) newErrors.docketNo = 'Docket number is required.';
    if (!String(formData.departmentId).trim()) newErrors.departmentId = 'Department is required.';
    if (!String(formData.quantity).trim()) newErrors.quantity = 'Quantity is required.';

    // If there are errors, block submit
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error('Please fix the required fields.');
      return;
    }

    try {
      if (isEditing) {
        const response = await UpdateOutwardCourier({ ...formData, id: editingId, });
        console.log("Outward response", response);
        toast.success(response?.res_message || 'Courier updated successfully!');
      } else {
        const response = await AddOutwardCourier(formData);
        console.log("Outward response", response);
        toast.success(response?.res_message || 'Courier added successfully!');
      }

      // Reset form & refresh data
      setFormData({
        courierName: '',
        courierId: '',
        dateTime: '',
        fromAddress: '',
        toAddress: '',
        docketNo: '',
        departmentId: '',
        Department: '',
        quantity: '',
        remarks: '',
      });
      setErrors({});
      setIsEditing(false);
      setEditingId(null);
      setIsModalOpen(false);
      fetchOutward(); // Refresh list
    } catch (err) {
      toast.error(isEditing ? 'Failed to update courier.' : 'Failed to add courier.');
      console.error(err);
    }
    const fetchCouriers = async () => {
      try {
        const response = await GetCouriers();
        setCouriers(response);

      } catch (error) {
        console.error('Error fetching Courers name:', error);
      }
    }
    fetchCouriers();
  };

  const handleEdit = (row) => {
    setFormData({
      courierName: row.courierName,
      courierId: row.CourierId,
      dateTime: row.DateTime, // For input type="datetime-local"
      fromAddress: row.FromAddress,
      toAddress: row.ToAddress,
      docketNo: row.DocketNo,
      departmentId: row.DepartmentID,
      Department: row.Department,
      quantity: row.Quantity,
      remarks: row.Remarks,
    });
    setEditingId(row.Id); // or row.courierId based on your backend
    setIsEditing(true);
    setIsModalOpen(true);
    setErrors({});
  };
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  // Function to toggle the export options panel
  const togglePanel = () => {
    setIsPanelOpen((prevState) => !prevState);
  };

  const handleExportOptionClick = (format) => {
    if (filteredLocations.length === 0) {
      toast.warning('No data available to export.');
      return;
    }
    if (format === 'excel') {
      exportToExcel(); // Call the Excel export function
    } else if (format === 'pdf') {
      exportToPDF(); // Call the PDF export function
    }

    // Close the panel after making a selection
    setIsPanelOpen(false);
  };

  const exportToExcel = () => {
    const filteredDataNee = filteredLocations.map((row) => ({
      CourierName: row.CourierName,
      DateTime: row.DateTime,
      DocketNumber: row.DocketNo,
      FromAddress: row.FromAddress,
      ToAddress: row.ToAddress,
      Department: row.DeptDescription,
      Quantity: row.Quantity,
      Department: row.DeptDescription,
      Remarks: row.Remarks,

    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredDataNee);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Outward Courier Reports');

    // Adjust column widths for better alignment
    worksheet['!cols'] = [
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Mobile
      { wpx: 150 }, // Visitor Mobile
      { wpx: 300 }, // Visitor Company
      { wpx: 300 }, // Visitor Company
      { wpx: 200 }, // Visitor Company
      { wpx: 200 }, // Visitor Company
      { wpx: 200 }, // Visitor Company



    ];

    XLSX.writeFile(workbook, 'Outward_Courier_Report.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const header = () => {
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");

      // Left Header Text
      doc.text("SecoreX - Visitor Management System", 14, 10);

      // Horizontal Line (Header bottom border)
      doc.setDrawColor(0); // Black color
      doc.setLineWidth(0.5);
      doc.line(14, 12, pageWidth - 14, 12);

      // Center Title below the line
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text("Outward Courier Reports", pageWidth / 2, 22, { align: "center" });

      doc.setFontSize(10); // Reset for table content
    };

    const footer = (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      const currentPage = data.pageNumber;

      // Footer Line
      doc.setDrawColor(0);
      doc.line(14, pageHeight - 15, pageWidth - 14, pageHeight - 15);

      // Left Footer Text
      doc.text("Outward Courier Reports", 14, pageHeight - 10);

      // Right Footer Text (Page X of Y)
      const pageText = `Page ${currentPage} of ${pageCount}`;
      const textWidth = doc.getTextWidth(pageText);
      doc.text(pageText, pageWidth - textWidth - 14, pageHeight - 10);
    };
    doc.autoTable({
      head: [
        ['Courier Name', 'DateTime', 'Docket Number', "From Address", 'To Address', 'Department', 'Quantity', 'Department', 'Remarks']
      ],
      body: filteredLocations.map((row) => [
        row.CourierName,
        row.DateTime,
        row.DocketNo,
        row.FromAddress,
        row.ToAddress,
        row.DeptDescription,
        row.Quantity,
        row.DeptDescription,
        row.Remarks,

      ]),
      startY: 30,
      theme: 'grid',
      didDrawPage: function (data) {
        header(data);
        footer(data);
      },
      columnStyles: {
        3: { cellWidth: 30 }, // From Address ⬅️ expanded
        4: { cellWidth: 30 }, // To Address ⬅️ expanded
      },
      margin: { top: 35 },
    });
    doc.save('Outward_Courier.pdf');
  };
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsPanelOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <Container>
      <Header>
        <Heading>Outward Courier Entry</Heading>
        <div style={{ display: 'flex', alignItems: 'center' }}>

          <SearchBox>
            <SearchIcon size={20} />
            <SearchInput
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </SearchBox>
          <DropdownContainerTwo ref={dropdownRef}>
            <ExportIcon onClick={togglePanel} title="Export">
              <FiDownload size={25} />
            </ExportIcon>
            {/* Show the panel with options if isPanelOpen is true */}
            {isPanelOpen && (
              <OptionsPanel>
                <OptionItem onClick={() => handleExportOptionClick('excel')}>Excel</OptionItem>
                <OptionItem onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItem>
              </OptionsPanel>
            )}
          </DropdownContainerTwo>
        </div>
      </Header>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button className="add-location" onClick={handleAddLocationClick}>
            Add Entry <FiPlus size={20} />
          </Button>
        </div>
        <div>
          <Label>Date : </Label>
          <Input
            type="date"
            required
            value={outwardDate}
            onChange={(e) => setOutwardDate(e.target.value)}
            style={{ padding: '6.5px 5px' }}
          />
        </div>

      </Card>
      <TableContainer>
        <StyledTable>
          <thead>
            <tr>
              <TableHeader colSpan={'10'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Outward Courier Entry Details</span>
                  <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                    {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                  </IconWrapper>
                </div>
              </TableHeader>
            </tr>
          </thead>
          {isExpanded && (
            <>
              <thead>
                <tr>
                  {/* <TableHeader onClick={() => handleSort('courierType')}>
                                                    Courier Type {sortColumn === 'courierType' && (sortDirection === 'asc' ? '↑' : '↓')}
                                                </TableHeader> */}
                  <TableHeader onClick={() => handleSort('CourierName')}>
                    Courier Name {sortColumn === 'CourierName' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('DateTime')}>
                    DateTime {sortColumn === 'DateTime' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('DocketNo')}>
                    Docket Number {sortColumn === 'DocketNo' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('FromAddress')}>
                    From Address {sortColumn === 'FromAddress' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('ToAddress')}>
                    To Address {sortColumn === 'ToAddress' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('DeptDescription')}>
                    Department {sortColumn === 'DeptDescription' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('Quantity')}>
                    Quantity {sortColumn === 'Quantity' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('DeptDescription')}>
                    Department {sortColumn === 'DeptDescription' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('Remarks')}>
                    Remarks {sortColumn === 'Remarks' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader>Action</TableHeader>
                </tr>
              </thead>
              <tbody>
                {currentItems && currentItems.length > 0 ? (
                  currentItems?.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{row.CourierName}</TableCell>
                      <TableCell>
                        {row.DateTime ? (() => {
                          const date = new Date(row.DateTime);
                          const mm = String(date.getMonth() + 1).padStart(2, '0');
                          const dd = String(date.getDate()).padStart(2, '0');
                          const yyyy = date.getFullYear();
                          const hh = String(date.getHours()).padStart(2, '0');
                          const min = String(date.getMinutes()).padStart(2, '0');
                          return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
                        })() : '-'}
                      </TableCell>
                      <TableCell>{row.DocketNo}</TableCell>
                      <TableCell style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        {row.FromAddress}
                      </TableCell>

                      <TableCell style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        {row.ToAddress}
                      </TableCell>
                      <TableCell>{row.DeptDescription}</TableCell>
                      <TableCell>{row.Quantity}</TableCell>
                      <TableCell>{row.DeptDescription}</TableCell>
                      <TableCell>{row.Remarks}</TableCell>
                      <TableCell>
                        <IconWrapper onClick={() => handleEdit(row)}>
                          <FiEdit />
                        </IconWrapper>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} style={{ textAlign: 'center', padding: '20px' }}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}

              </tbody>
            </>
          )}
        </StyledTable>
        {isExpanded && (
          <>
            <PaginationContainer>
              <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                Previous
              </PaginationButton>

              <DropdownSelect value={currentPage} onChange={handlePageChange}>
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    Page {i + 1}
                  </option>
                ))}
              </DropdownSelect>

              <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </PaginationButton>
            </PaginationContainer>
          </>
        )}
        {isModalOpen && (
          <ModalContainer>
            <ModalHeader>
              <ModalTitle>{isEditing ? "Update Outward Courier Entry" : "Add Outward Courier Entry"}</ModalTitle>
              <CloseIcon size={24} onClick={handleCloseModal} />
            </ModalHeader>

            <InputGroup>
              <FlexRow>
                {/* Left Column */}
                <InputFieldHalf>
                  <Label>Courier Name<Asterisk>*</Asterisk></Label>
                  {!isEditing && formData.courierId === "0" ? (
                    <Input
                      type="text"
                      placeholder="Enter Courier Name"
                      required
                      value={formData.courierName || ""}
                      hasError={!!errors.courierName}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          courierName: e.target.value,
                          courierId: "0", // Keep the courierId as "0"
                        })
                      }
                    />
                  ) : (
                    <DropdownSelect
                      required
                      value={formData.courierId}
                      hasError={!!errors.courierId}
                      style={{ padding: '7.8px 6px' }}
                      onChange={(e) => {
                        const val = e.target.value;
                        setFormData({
                          ...formData,
                          courierId: val,
                          courierName: val === "0" ? formData.courierName || "" : "",
                        });
                      }}
                    >
                      <option value="">Select Company</option>
                      {couriers
                        .filter(c => c.courierName?.trim())
                        .map((courier) => (
                          <option key={courier.id} value={courier.id}>
                            {courier.courierName}
                          </option>
                        ))}
                      <option value="0">Others</option>
                    </DropdownSelect>
                  )}
                  {/* {errors.courierId && <span className="error">{errors.courierId}</span>} */}



                  {/* <Label>Courier Type</Label> */}
                  {/* <DropdownSelect name="courierType" required>
                                        <option value="">Select Courier Type</option>
                                        <option value="Inward">Inward</option>
                                        <option value="Outward">Outward</option>
                                    </DropdownSelect> */}

                  <Label>Date and Time<Asterisk>*</Asterisk></Label>
                  <StyledDatePicker
                    selected={formData.dateTime ? new Date(formData.dateTime) : null}
                    onChange={(date) => {
                      const formatted = format(date, "yyyy-MM-dd'T'HH:mm");
                      setFormData({ ...formData, dateTime: formatted });
                    }}
                    showTimeSelect
                    dateFormat="dd-MM-yyyy h:mm aa"
                    placeholderText="Select date and time"
                    $hasError={!!errors.dateTime}
                  />
                  {/* {errors.dateTime && <span className="error">{errors.dateTime}</span>} */}
                  <Label>Quantity<Asterisk>*</Asterisk></Label>
                  <Input
                    type="number"
                    placeholder="Enter Quantity"
                    required
                    min={1} // Ensures only positive values (1 and above)
                    value={formData.quantity}
                    hasError={!!errors.quantity}
                    onChange={(e) => {
                      const value = e.target.value;
                      const numericValue = value.replace(/[^0-9]/g, ''); // removes non-digit characters

                      // Optional: prevent 0 as a valid value
                      setFormData({ ...formData, quantity: numericValue });
                    }}
                  />


                  <Label>From Address<Asterisk>*</Asterisk></Label>
                  <TextArea
                    type="text"
                    placeholder="Enter From Address"
                    required
                    value={formData.fromAddress}
                    hasError={!!errors.fromAddress}
                    onChange={(e) => setFormData({ ...formData, fromAddress: e.target.value })}
                  />
                  {/* {errors.fromAddress && <span className="error">{errors.fromAddress}</span>} */}



                  {/* {errors.toAddress && <span className="error">{errors.toAddress}</span>} */}


                </InputFieldHalf>

                {/* Right Column */}
                <InputFieldHalf>


                  <Label>Docket Number<Asterisk>*</Asterisk></Label>
                  <Input
                    type="text"
                    placeholder="Enter Docket Number"
                    required
                    value={formData.docketNo}
                    hasError={!!errors.docketNo}
                    onChange={(e) => {
                      const value = e.target.value;
                      const sanitized = value.replace(/[^a-zA-Z0-9\s]/g, '');
                      setFormData({ ...formData, docketNo: sanitized });
                    }}
                  />
                  {/* {errors.docketNo && <span className="error">{errors.docketNo}</span>} */}



                  {/* {errors.departmentId && <span className="error">{errors.departmentId}</span>} */}




                  {/* {errors.quantity && <span className="error">{errors.quantity}</span>} */}

                  <Label>Department<Asterisk>*</Asterisk> </Label>
                  <DropdownSelect
                    required
                    value={formData.departmentId}
                    hasError={!!errors.departmentId}
                    style={{ padding: '9px 6px' }}

                    onChange={(e) =>
                      setFormData({ ...formData, departmentId: e.target.value })
                    }
                  >
                    <option value="">Select Department</option>
                    {departments
                      .filter((dept) => !dept.isDeleted)
                      .map((dept) => (
                        <option key={dept.id} value={dept.id}>
                          {dept.deptDescription}
                        </option>
                      ))}
                  </DropdownSelect>


                  <Label>Remarks</Label>
                  <Input
                    type="text"
                    placeholder="Enter Remarks"
                    value={formData.remarks}
                    onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
                  />
                  <Label>To Address<Asterisk>*</Asterisk></Label>
                  <TextArea
                    type="text"
                    placeholder="Enter To Address"
                    required
                    value={formData.toAddress}
                    hasError={!!errors.toAddress}
                    onChange={(e) => setFormData({ ...formData, toAddress: e.target.value })}
                  />



                </InputFieldHalf>
              </FlexRow>
            </InputGroup>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
              <ResetButton onClick={handleReset}>Reset</ResetButton>
              <SubmitButton onClick={() => {
                handleSubmit();
              }
              }>Submit</SubmitButton>
            </div>
          </ModalContainer>
        )}


      </TableContainer>
      <ToastContainer />

    </Container>
  );
};

export default OutwardCourierPage;
